module.exports = __webpack_public_path__ + "static/media/Voting.da2eedc5.png";